import Vue from 'vue';

export class Utils{

    static simnao(){
        return[
            {value: true, name: 'SIM'},
            {value: false, name: 'NÃO'}
        ];
    }

    static estados(){
        return[
            {value: 'AC', name: 'ACRE'},
            {value: 'AL', name: 'ALAGOAS'},
            {value: 'AP', name: 'AMAPÁ'},
            {value: 'AM', name: 'AMAZONAS'},
            {value: 'BA', name: 'BAHIA'},
            {value: 'CE', name: 'CEARÁ'},
            {value: 'DF', name: 'DISTRITO FEDERAL'},
            {value: 'ES', name: 'ESPIRITO SANTO'},
            {value: 'GO', name: 'GOIÁS'},
            {value: 'MA', name: 'MARANHÃO'},
            {value: 'MT', name: 'MATO GROSSO'},
            {value: 'MS', name: 'MATO GROSSO DO SUL'},
            {value: 'MG', name: 'MINAS GERAIS'},
            {value: 'PA', name: 'PARÁ'},
            {value: 'PB', name: 'PARAÍBA'},
            {value: 'PR', name: 'PARANÁ'},
            {value: 'PE', name: 'PERNAMBUCO'},
            {value: 'PI', name: 'PIAUÍ'},
            {value: 'RJ', name: 'RIO DE JANEIRO'},
            {value: 'RN', name: 'RIO GRANDE DO NORTE'},
            {value: 'RS', name: 'RIO GRANDE DO SUL'},
            {value: 'RO', name: 'RONDÔNIA'},
            {value: 'RR', name: 'RORAIMA'},
            {value: 'SC', name: 'SANTA CATARINA'},
            {value: 'SP', name: 'SÃO PAULO'},
            {value: 'SE', name: 'SERGIPE'},
            {value: 'TO', name: 'TOCANTINS'},
        ];
    }

}
